export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8682.12e2b088.jpg";